var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"div-100x",attrs:{"flat":"","color":"transparent"}},[_c('InfoDescription',{attrs:{"center":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }